<template>
  <Modal title="编辑订单" v-model="editModal">
    <Form ref="form" class="form" :label-width="100"
          :model="formData" :rules="formRule">
      <Row>
        <i-col :xs="24" :sm="11">
          <Form-item label="学生姓名" prop="contractName">
            <Input v-model="formData.contractName" placeholder="选填"/>
          </Form-item>
        </i-col>
        <i-col :xs="24" :sm="11">
          <Form-item label="监护人" prop="guardian">
            <Input v-model="formData.guardian" placeholder="选填"/>
          </Form-item>
        </i-col>
<!--        <i-col :xs="24" :sm="11">-->
<!--          <Form-item label="收款公司" prop="payCompany">-->
<!--            <Select v-model.number="formData.payCompany">-->
<!--              <Option :value="10">邦德尔(销售)</Option>-->
<!--              <Option :value="11">虹兴达(学导)</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">取消</Button>
      <Button type="primary" size="large" :loading="loading" @click="onInsert">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'EditOrderModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      fundData: {
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        loading: false,
        materialPrice: [],
        formData: {
          bookNum: null,
          address: '',
          contractName: '',
          guardian: '',
          bookMaterialLevel: [],
          needInvoice: '0',
          needContract: '0',
          invoiceDetail: '',
        },
        formRule: {
          bookMaterialLevel: [
            {type: 'array', required: true, message: '不能为空', trigger: 'blur'}
          ],
          address: [
            {type: 'string', required: true, message: '不能为空', trigger: 'blur'}
          ],
          contractName: [
            {type: 'string', required: true, message: '不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      onInsert () {
        let self = this
        self.loading = true
        self.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loading = false
            return
          }

          self.$http.post('/fundPackage/update', {
            id: self.formData.id,
            uid: self.formData.uid,
            contractName: self.formData.contractName,
            needInvoice: self.formData.needInvoice,
            needContract: self.formData.needContract,
            invoiceDetail: self.formData.invoiceDetail,
          }).then(res => {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              this.successCallback()
              self.onClose()
              self.onSuccess()
            }
            self.loading = false
          }).catch(e => {
            self.onClose()
            self.loading = false
          })
        })
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      allClear () {
        this.formData.bookMaterialLevel = []
      }
    },
    watch: {
      value (val) {
        let self = this
        if (val && this.fundData) {
          this.formData = this.fundData
          self.$http.get('/materialPrice/list').then(function (res) {
            if (res.data) {
              self.materialPrice = res.data
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditOrderModal.vue?7ab6a284